var map = {
  "./assets/favicons-prodeu1/android-chrome-192x192.png": "662666",
  "./assets/favicons-prodeu1/android-chrome-512x512.png": "811658",
  "./assets/favicons-prodeu1/apple-touch-icon.png": "331021",
  "./assets/favicons-prodeu1/browserconfig.xml": "356393",
  "./assets/favicons-prodeu1/favicon-16x16.png": "65828",
  "./assets/favicons-prodeu1/favicon-32x32.png": "322720",
  "./assets/favicons-prodeu1/favicon-alert-16x16.png": "676997",
  "./assets/favicons-prodeu1/favicon-alert-32x32.png": "331573",
  "./assets/favicons-prodeu1/favicon-alert.ico": "320566",
  "./assets/favicons-prodeu1/favicon.ico": "736351",
  "./assets/favicons-prodeu1/mstile-150x150.png": "563022",
  "./assets/favicons-prodeu1/site.webmanifest": "880572",
  "./assets/favicons-prodeu1/upc-favicon.ico": "51354"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 637391;
